import {
  faVolumeHigh,
  faVolumeLow,
  faVolumeXmark,
} from '@fortawesome/pro-solid-svg-icons';
import { Popover } from '@rocketlane/ui';
import {
  useMediaRemote,
  useMediaState,
  VolumeSlider as VidStackVolumeSlider,
} from '@vidstack/react';
import { useCallback } from 'react';
import { PlayerControlButton } from './base-button';
import { useVideoPlayerContext } from '../../player-context';

const VolumeSliderContent = () => {
  const { playerRef } = useVideoPlayerContext();
  const isFullscreen = useMediaState('fullscreen', playerRef!);

  return (
    <VidStackVolumeSlider.Root
      orientation="vertical"
      className={`relative flex flex-col ${isFullscreen ? 'h-[120px]' : 'h-[80px]'} w-[6px] cursor-pointer touch-none select-none justify-center`}
    >
      <VidStackVolumeSlider.Track className="relative h-full w-full bg-[var(--scarlet-gray-100)] rounded-8">
        <VidStackVolumeSlider.TrackFill
          className="absolute bottom-0 w-full h-[var(--slider-fill)] rounded-8"
          style={{
            backgroundImage:
              'linear-gradient(90deg, var(--blue-40) 0%, var(--blue-60) 100%)',
          }}
        />
      </VidStackVolumeSlider.Track>
      <VidStackVolumeSlider.Thumb
        className="absolute left-1/2 h-[8px] w-[8px] -translate-x-1/2 bg-white border border-solid border-[var(--blue-40)] rounded-8"
        style={{
          bottom:
            'max(0%, min(calc(var(--slider-fill) - 4px), calc(100% - 8px)))',
        }}
      />
    </VidStackVolumeSlider.Root>
  );
};

export const VolumeControls = () => {
  const { playerRef } = useVideoPlayerContext();
  const volume = useMediaState('volume', playerRef!);
  const isMuted = useMediaState('muted', playerRef!);
  const isFullscreen = useMediaState('fullscreen', playerRef!);
  const remote = useMediaRemote(playerRef);
  const getVolumeIcon = useCallback(() => {
    if (isMuted || volume === 0) {
      return faVolumeXmark;
    }

    if (volume < 0.5) {
      return faVolumeLow;
    }

    return faVolumeHigh;
  }, [isMuted, volume]);
  const handleToggleMute = useCallback(() => {
    remote.toggleMuted();
  }, [remote]);

  if (isFullscreen) {
    return (
      <div className="relative flex items-center group/volume">
        <PlayerControlButton
          icon={getVolumeIcon()}
          onClick={handleToggleMute}
        />
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 opacity-0 hover:opacity-100 group-hover/volume:opacity-100 transition-opacity pointer-events-none hover:pointer-events-auto group-hover/volume:pointer-events-auto p-02 rounded-8 bg-[var(--scarlet-gray-30)]">
          <VolumeSliderContent />
        </div>
      </div>
    );
  }

  return (
    <Popover
      triggerMode="hover"
      align="center"
      side="top"
      content={<VolumeSliderContent />}
    >
      <div>
        <PlayerControlButton
          icon={getVolumeIcon()}
          onClick={handleToggleMute}
        />
      </div>
    </Popover>
  );
};
